import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  blueMui,
  deepPurpleMui,
  greyMui,
  lightBlueMui,
  redMui,
  rydeColors,
} from "@ryde/theme";

export const CoursesCalendarRideProduceDrawerStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "courses-calendar-ride-produce-drawer-content",
  },
)`
  .cc-ride-produce-alert {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-block: 16px;
    margin-inline: 0 16px;
    padding: 10px 12px;
    border-radius: 8px;
    background-color: ${lightBlueMui._50};
    border: 1px solid ${lightBlueMui._400};
    box-shadow: 0 1px 4px rgba(3, 169, 244, 0.12);
    font-size: 13px;
    line-height: 1.45;
    color: ${blueGreyMui._800};
  }

  .cc-ride-produce-alert__icon {
    flex-shrink: 0;
    display: inline-flex;
    margin-top: 1px;
    color: ${lightBlueMui._700};
  }

  .cc-ride-produce-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    margin: 0 16px 12px 0;
  }

  .cc-ride-produce-filter {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    font-size: 13px;
    font-weight: 500;
    line-height: 1;
    color: ${blueGreyMui._800};
    cursor: pointer;
    user-select: none;

    [data-e2e="checkbox-mui-container"] {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      line-height: 0;
      padding: 0;
      flex-shrink: 0;
    }

    > span {
      line-height: 1.25;
      padding-top: 1px;
    }
  }

  .cc-ride-produce-toolbar__actions {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-inline-start: auto;
  }

  .cc-ride-produce-selected-badge,
  .cc-ride-produce-badge {
    display: inline-flex;
    align-items: center;
    padding: 3px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.3;
    white-space: nowrap;
    border: 1px solid transparent;
  }

  .cc-ride-produce-selected-badge {
    background-color: ${lightBlueMui._50};
    border-color: ${lightBlueMui._200};
    color: ${blueMui._700};
  }

  .cc-ride-produce-badge--already-produced {
    background-color: ${blueGreyMui._50};
    border-color: ${blueGreyMui._300};
    color: ${blueGreyMui._600};
  }

  .cc-ride-produce-badge--skipped {
    background-color: ${redMui._50};
    border-color: ${redMui._300};
    color: ${redMui._800};
  }

  .cc-ride-produce-toolbar__icon-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: 1px solid ${lightBlueMui._200};
    border-radius: 6px;
    background-color: ${lightBlueMui._50};
    color: ${blueMui._700};
    cursor: pointer;
    transition:
      background-color 0.15s ease,
      border-color 0.15s ease,
      color 0.15s ease;

    &:hover:not(:disabled) {
      background-color: ${lightBlueMui._100};
      border-color: ${lightBlueMui._300};
      color: ${blueMui._800};
    }

    &:disabled {
      opacity: 0.45;
      cursor: default;
      color: ${blueGreyMui._400};
      background-color: ${greyMui._100};
      border-color: ${greyMui._300};
    }

    svg {
      font-size: 18px;
    }
  }

  .cc-ride-produce-check {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
  }

  .cc-ride-produce-check--disabled {
    opacity: 0.4;
    pointer-events: none;
  }

  .cc-ride-produce-progress {
    margin-block-end: 16px;
    margin-inline: 0 16px;
  }

  .cc-ride-produce-table-wrap {
    margin-inline-end: 16px;
    overflow: auto;
    max-width: 100%;
    border-radius: 8px;
    border: 1px solid ${greyMui._300};
    box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);
    background-color: ${rydeColors.white};
  }

  .cc-ride-produce-empty {
    padding: 16px;
    text-align: center;
    font-size: 12px;
    color: ${blueGreyMui._600};
  }

  .cc-ride-produce-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 13px;
    line-height: 1.43;

    thead th {
      position: sticky;
      top: 0;
      z-index: 1;
      background-color: ${greyMui._100};
      color: ${blueGreyMui._700};
      font-weight: 600;
      font-size: 12px;
      line-height: 1.2;
      text-align: start;
      padding: 5px 16px;
      border-bottom: 1px solid ${greyMui._300};
      white-space: nowrap;
    }

    thead th:first-child {
      border-start-start-radius: 7px;
    }

    thead th:last-child {
      border-start-end-radius: 7px;
    }

    tbody td {
      padding: 8px 16px;
      border-bottom: 1px solid ${greyMui._200};
      vertical-align: middle;
      background-color: ${rydeColors.white};
    }

    tbody tr:last-child td {
      border-bottom: none;
    }

    tbody tr:last-child td:first-child {
      border-end-start-radius: 7px;
    }

    tbody tr:last-child td:last-child {
      border-end-end-radius: 7px;
    }
  }

  .cc-ride-produce-col--center {
    text-align: center;
  }

  .cc-ride-produce-col--check {
    width: 36px;
    padding-inline: 10px !important;
    text-align: center;
  }

  thead th.cc-ride-produce-col--check {
    padding-inline: 10px;
  }

  .cc-ride-produce-col--icon {
    width: 56px;
    padding-inline: 8px;
    text-align: center;
  }

  .cc-ride-produce-seats-icon {
    display: inline-flex;
    align-items: center;
    color: ${blueGreyMui._500};
  }

  .cc-ride-produce-dir {
    font-weight: 600;
  }

  .cc-ride-produce-dir--a {
    color: ${redMui._800};
  }

  .cc-ride-produce-dir--b {
    color: ${blueMui._800};
  }

  tr.cc-ride-produce-row--skipped td {
    color: ${blueGreyMui._400};
  }

  tr.cc-ride-produce-row--skipped .cc-ride-produce-dir,
  tr.cc-ride-produce-row--skipped .cc-ride-produce-dir--a,
  tr.cc-ride-produce-row--skipped .cc-ride-produce-dir--b {
    color: ${blueGreyMui._400};
    opacity: 1;
  }

  tr.cc-ride-produce-row--skipped .cc-ride-produce-course-type-icon svg path,
  tr.cc-ride-produce-row--skipped
    .cc-ride-produce-course-type-icon
    svg
    [fill]:not([fill="none"]) {
    fill: ${blueGreyMui._400};
  }

  tr.cc-ride-produce-row--canceled td {
    color: ${blueGreyMui._500};
  }

  .cc-ride-produce-ride-cell {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }

  .cc-ride-produce-ride-id-row {
    display: inline-flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0;
  }

  .cc-ride-produce-ride-status {
    font-size: 11px;
    font-weight: 600;
    color: inherit;
    margin-inline-start: 4px;
  }

  .cc-ride-produce-skip-reason {
    font-size: 11px;
    font-weight: 600;
    color: ${blueGreyMui._500};
  }

  tr.cc-ride-produce-row--canceled .cc-ride-produce-skip-reason {
    color: ${rydeColors.red};
  }

  .cc-ride-produce-course-cell {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
  }

  .cc-ride-produce-course-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${rydeColors.black};
    text-decoration: none;
  }

  .cc-ride-produce-course-type-icon {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    line-height: 0;

    svg {
      width: 16px;
      height: 16px;
    }
  }

  .cc-ride-produce-course-link,
  .cc-ride-produce-ride-link {
    cursor: pointer;
    color: ${deepPurpleMui.A700};
    text-decoration: underline;
    border: none;
    background: none;
    padding: 0;
    font: inherit;
    line-height: inherit;

    &:hover {
      color: ${deepPurpleMui.A400};
    }
  }

  .cc-ride-produce-ride-link {
    font-size: 11px;
    font-weight: 600;
  }

  .cc-ride-produce-ride-id {
    font-size: 11px;
    font-weight: 600;
    color: inherit;
  }

  tr.cc-ride-produce-row--skipped .cc-ride-produce-course-link,
  tr.cc-ride-produce-row--skipped .cc-ride-produce-ride-link {
    color: ${blueGreyMui._400};

    &:hover {
      color: ${blueGreyMui._600};
    }
  }

  tr.cc-ride-produce-row--skipped .cc-ride-produce-course-name {
    color: ${blueGreyMui._400};
  }
`;
